import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "m12 14 4-4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M3.34 19a10 10 0 1 1 17.32 0", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Gauge";
const Gauge = memo(themed(Icon));
export {
  Gauge
};
//# sourceMappingURL=gauge.js.map
